var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlarmOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(.917 1.375)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#E24545",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M0 19.158L10.06 0 20.121 19.158zM10.06 8.067V12.1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.06,
    cy: 15.125,
    fill: "#E24545",
    fillRule: "nonzero",
    rx: 1.006,
    ry: 1.008
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarmOutline);
export default __webpack_public_path__ + "static/media/alarm-outline.f3c51583e04d70f6ea36fc54b0575724.svg";
export { ForwardRef as ReactComponent };